import React, { useCallback, useState } from 'react';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { useMemoTuple, useSubmitter } from '../../platform/Hook';
import { ResultInfoForSubmitter } from '../../ui/ResultInfo';
import { useResolve } from '../Container';
import { Copy, Spacer, ToggleFrame, ToggleLabel } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { Button, Input, Prompt, Toggle } from './../../ui';
import { workspaceCreate } from './WorkspaceCommands';

export const CreateWorkspacePopup: LFC<PopupProps> = ({ action, dismiss }) => {

    const dispatch = useResolve(CommandDispatcher);

    const [label, setLabel] = useState('');
    const [desc, setDesc] = useState('');
    const [makePublic, setMakePublic] = useState(false);

    const invalid = !label.trim();
    const inputs = useMemoTuple([label, desc, true, makePublic]);

    const [onSubmit, working, result] = useSubmitter(async () => {
        action(await dispatch(workspaceCreate, inputs));
    }, [inputs]);

    const onPromptAction = useCallback((confirm: boolean) => {
        if (!confirm) dismiss();
        else if (!invalid) onSubmit();
    }, [invalid, onSubmit]);

    return <Prompt onAction={working ? null : onPromptAction}>
        <Popup w={32}>
            <Popup.Close onAction={() => onPromptAction(false)} />
            <Popup.Title>Create Workspace</Popup.Title>
            <Popup.Content>
                <Copy>
                    Workspaces are a way of organizing your boards.  We recommend creating separate workspaces
                    for different teams, but you can do it however you like!
                </Copy>
                <Spacer f={2} />
                <Input
                    label="Name"
                    placeholder="e.g. Product Team"
                    autoFocus
                    value={label}
                    onChange={setLabel}
                />
                <Spacer f={2} />
                <Input
                    label="Description"
                    hint="(Optional)"
                    placeholder="e.g. Where the real work happens!"
                    value={desc}
                    onChange={setDesc}
                />
                <Spacer f={3} />
                <ToggleFrame>
                    <Toggle value={makePublic} onAction={() => setMakePublic(x => !x)} />
                    <ToggleLabel>Make public</ToggleLabel>
                </ToggleFrame>
                <Spacer f={2} />
                <ResultInfoForSubmitter result={result} />
            </Popup.Content>
            <Popup.Actions>
                <Button disabled={invalid || working} variant="primary" onAction={onSubmit}>
                    {working ? 'Creating...' : 'Create'}
                </Button>
            </Popup.Actions>
        </Popup>
    </Prompt>;
};
